import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "../utils/axios";
import { config } from "../constants";

const SMSUnreadContext = createContext({});

export const useSMSUnread = () => useContext(SMSUnreadContext);

export const SMSUnreadProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const fetchNotifications = () => {
      axios.get(`${config.url.SMS_URL}/api/sms/notifications`)
        .then((res) => {
          setNotifications(res.data.notifications || []);
        })
        .catch(() => {});
    };
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 20000);
    return () => clearInterval(interval);
  }, []);

  const totalUnread = notifications.filter((n) => !n.read_at).length;

  const messageNotifications = notifications.filter((n) => n.type === "message_received");
  const taskNotifications = notifications.filter((n) => n.type === "task_assigned" || n.type === "task_note_mention");

  const markNotificationsRead = useCallback((ids) => {
    axios.post(`${config.url.SMS_URL}/api/sms/notifications/mark-read`, { ids }).catch(() => {});
    setNotifications((prev) => prev.map((n) => ids.includes(n.id) ? { ...n, read_at: new Date().toISOString() } : n));
  }, []);

  const markCustomerRead = useCallback((customer) => {
    const matching = notifications.filter(
      (n) => n.type === "message_received" && n.metadata?.customer_name === customer
    );
    if (matching.length > 0) {
      markNotificationsRead(matching.map((n) => n.id));
    }
    // Also mark communications as read for thread-level unread dots
    axios.post(`${config.url.SMS_URL}/api/sms/conversations/mark-read-by-customer`, { customer_name: customer }).catch(() => {});
  }, [notifications, markNotificationsRead]);

  return (
    <SMSUnreadContext.Provider value={{
      notifications, messageNotifications, taskNotifications,
      totalUnread, markNotificationsRead, markCustomerRead,
    }}>
      {children}
    </SMSUnreadContext.Provider>
  );
};
